// Mock data for RunTheRays website

export const mockServices = [
  {
    id: 1,
    title: "Sourcing Solutions",
    icon: "Search",
    description: "Connect with reliable, verified manufacturers and suppliers across China.",
    features: [
      "Supplier verification and assessment",
      "Product sourcing and price negotiation",
      "Cost optimization strategies",
      "Market research and product analysis"
    ]
  },
  {
    id: 2,
    title: "Warehousing Services",
    icon: "Warehouse",
    description: "State-of-the-art facilities with advanced inventory management systems.",
    features: [
      "Secure and modern storage facilities",
      "Advanced inventory management (SAP)",
      "Order fulfillment and consolidation",
      "Flexible storage solutions"
    ]
  },
  {
    id: 3,
    title: "Quality Control & Inspection",
    icon: "CheckCircle",
    description: "Rigorous inspections and compliance checks for international standards.",
    features: [
      "Pre-shipment inspections",
      "Factory audits",
      "Product testing and certification",
      "Compliance and standards verification"
    ]
  }
];

export const mockIndustries = [
  { id: 1, name: "Consumer Goods", icon: "ShoppingBag" },
  { id: 2, name: "Electronics", icon: "Cpu" },
  { id: 3, name: "Apparel & Textiles", icon: "Shirt" },
  { id: 4, name: "Building Materials", icon: "Building2" },
  { id: 5, name: "Machinery & Equipment", icon: "Settings" },
  { id: 6, name: "FMCG & Retail", icon: "Store" },
  { id: 7, name: "Automobile", icon: "Car" }
];

export const mockStats = [
  { id: 1, value: "300+", label: "Successful Projects" },
  { id: 2, value: "100+", label: "Trusted Partners" },
  { id: 3, value: "25+", label: "Countries Served" },
  { id: 4, value: "2019", label: "Founded" }
];

export const mockApproach = [
  { id: 1, step: "01", title: "Understand Your Business Needs", description: "Deep dive into your requirements and goals" },
  { id: 2, step: "02", title: "Source & Verify Reliable Suppliers", description: "Leverage our extensive network for the best match" },
  { id: 3, step: "03", title: "Monitor Production & Quality", description: "Rigorous oversight throughout manufacturing" },
  { id: 4, step: "04", title: "Secure Warehousing & Inventory", description: "Advanced SAP-managed storage solutions" },
  { id: 5, step: "05", title: "Coordinate Logistics & Shipment", description: "Seamless delivery to your destination" }
];

export const mockWhyChoose = [
  "One-stop supply chain solutions",
  "Deep local expertise in China",
  "Strong supplier and logistics network",
  "Transparent processes & real-time updates",
  "Proven track record across multiple industries"
];

// Mock form submission
export const submitQuoteRequest = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Quote request submitted (mock):', data);
      resolve({ success: true, message: 'Quote request received successfully!' });
    }, 1000);
  });
};